import { JetView } from 'webix-jet';
import { devConfig, profile } from '../../../config/config';

/**
 * Class representing a view for filtering user profile options.
 * @extends JetView
 */
export default class FilterPerfilOpcionesView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const filter = {
            margin: 5,
            minHeight: screen.width < 500 ? 150 : 0, // Minimum height based on screen width
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for user type selection
                            name: 'TypeUser',
                            id: 'TypeUser',
                            label: _('Tipo de usuario'), // User type label
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [],
                            required: true, // Field is required
                            invalidMessage: _('Campo Requerido'), // Error message for required field
                        },
                        {
                            view: 'combo', // Combo box for username selection
                            name: 'Username',
                            id: 'Username',
                            label: _('Usuario'), // Username label
                            labelPosition: 'top',
                            options: {
                                keyPressTimeout: 1000, // Delay for key press
                                body: {
                                    dataFeed: devConfig.geturlApi() + 'Admin/GetUserFilterSearch', // API endpoint for user search
                                    ready: function () {},
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [filter], // Include filter in upper section
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    hidden: !devConfig.getPermAction('createPermission', 'Add'), // Hide button if permission is not granted
                    css: 'prm-createPermission',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            minWidth: 200,
                            view: 'button', // Button to create permission
                            value: _('Crear Permiso'), // Button label
                            type: 'form',
                            width: screen == 'small' ? 0 : 150,
                            click: () => {
                                this.app.callEvent('createPermission:button', [[]]); // Trigger create permission event
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for collapsible sections
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters section
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main view is a form
            type: 'clean',
            rows: [accordion_section], // Include accordion section
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const vthis = this; // Reference to the current instance
        var popupAdd; // Variable to hold the popup for adding permissions
        $$('Username').hide(); // Initially hide the username field

        // Fetch user types from the API
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'AdminUser/GetTypeUser', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse response data
                    var optionsTypeUser = $$('TypeUser').getList(); // Get the list of user types
                    optionsTypeUser.clearAll(); // Clear existing options
                    optionsTypeUser.parse(data.Data); // Populate with new data
                },
            });

        // Event handler for changes in user type selection
        $$('TypeUser').attachEvent('onChange', function (newv, oldv) {
            $$('Username').hide(); // Hide username field by default
            if (newv != 'CUSTOM') {
                // If selected user type is not CUSTOM
                webix
                    .ajax()
                    .headers({
                        'Content-type': 'application/json',
                    })
                    .post(devConfig.geturlApi() + 'UserManagement/GetGroupPermissions2?roleId=' + newv, '', {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message(_('Error! ')); // Error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text.replace(/"UserName"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse and format response data
                            var arrayIncludedPermissionList = data.Data.IncludedPermissionList.split(','); // List of included permissions
                            var excludedPermissions = data.Data.ExcludedPermissions; // List of excluded permissions
                            excludedPermissions.forEach(function (obj) {
                                obj.markCheckbox = 0; // Initialize checkbox state
                                if (obj.data != undefined) {
                                    obj.data.forEach(function (obj2) {
                                        obj2.markCheckbox = 0; // Initialize checkbox state for nested data
                                        if (obj2.data != undefined) {
                                            obj2.data.forEach(function (obj3) {
                                                obj3.markCheckbox = 0; // Initialize checkbox state for nested data
                                            });
                                        }
                                    });
                                }
                            });
                            var filterList = []; // List to hold filtered permissions
                            excludedPermissions.forEach(function (obj) {
                                filterList.push(obj); // Add to filter list
                                arrayIncludedPermissionList.forEach(function (element) {
                                    if (obj.id == element) {
                                        obj.markCheckbox = 1; // Mark checkbox if included
                                    }
                                });
                                if (obj.data != undefined) {
                                    obj.data.forEach(function (obj2) {
                                        filterList.push(obj2); // Add nested data to filter list
                                        arrayIncludedPermissionList.forEach(function (element) {
                                            if (obj2.id == element) {
                                                obj2.markCheckbox = 1; // Mark checkbox if included
                                            }
                                        });
                                        if (obj2.data != undefined) {
                                            obj2.data.forEach(function (obj3) {
                                                filterList.push(obj3); // Add nested data to filter list
                                                arrayIncludedPermissionList.forEach(function (element) {
                                                    if (obj3.id == element) {
                                                        obj3.markCheckbox = 1; // Mark checkbox if included
                                                    }
                                                });
                                            });
                                        }
                                    });
                                }
                            });
                            vthis.app.callEvent('ExcludedPermissions', [
                                excludedPermissions, // Trigger event with excluded permissions
                            ]);
                            $$('dataview').clearAll(); // Clear data view
                            $$('dataview').parse(excludedPermissions); // Populate data view with excluded permissions
                            $$('FilterFather').getList().clearAll(); // Clear filter options
                            $$('FilterFather').getList().parse(filterList); // Populate filter options
                            $$('FilterFather').setValue(''); // Reset filter selection
                            $$('b5').collapse(); // Collapse filters section
                            $$('dataview').scrollTo(100, 0); // Scroll data view
                        },
                    });
            } else {
                if (newv == 'CUSTOM') {
                    $$('Username').show(); // Show username field for CUSTOM selection
                    $$('dataview').clearAll(); // Clear data view
                    $$('FilterFather').getList().clearAll(); // Clear filter options
                    $$('dataview').scrollTo(100, 0); // Scroll data view
                }
            }
        });

        // Event handler for changes in username selection
        $$('Username').attachEvent('onChange', function (newv, oldv) {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'UserManagement/GetGroupPermissions2?roleId=CUSTOM&UserId=' + newv, '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text.replace(/"UserName"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse and format response data
                        var arrayIncludedPermissionList = data.Data.IncludedPermissionList.split(','); // List of included permissions
                        var excludedPermissions = data.Data.ExcludedPermissions; // List of excluded permissions
                        excludedPermissions.forEach(function (obj) {
                            obj.markCheckbox = 0; // Initialize checkbox state
                            if (obj.data != undefined) {
                                obj.data.forEach(function (obj2) {
                                    obj2.markCheckbox = 0; // Initialize checkbox state for nested data
                                    if (obj2.data != undefined) {
                                        obj2.data.forEach(function (obj3) {
                                            obj3.markCheckbox = 0; // Initialize checkbox state for nested data
                                        });
                                    }
                                });
                            }
                        });
                        var filterList = []; // List to hold filtered permissions
                        excludedPermissions.forEach(function (obj) {
                            filterList.push(obj); // Add to filter list
                            arrayIncludedPermissionList.forEach(function (element) {
                                if (obj.id == element) {
                                    obj.markCheckbox = 1; // Mark checkbox if included
                                }
                            });
                            if (obj.data != undefined) {
                                obj.data.forEach(function (obj2) {
                                    filterList.push(obj2); // Add nested data to filter list
                                    arrayIncludedPermissionList.forEach(function (element) {
                                        if (obj2.id == element) {
                                            obj2.markCheckbox = 1; // Mark checkbox if included
                                        }
                                    });
                                    if (obj2.data != undefined) {
                                        obj2.data.forEach(function (obj3) {
                                            filterList.push(obj3); // Add nested data to filter list
                                            arrayIncludedPermissionList.forEach(function (element) {
                                                if (obj3.id == element) {
                                                    obj3.markCheckbox = 1; // Mark checkbox if included
                                                }
                                            });
                                        });
                                    }
                                });
                            }
                        });
                        vthis.app.callEvent('ExcludedPermissions', [
                            excludedPermissions, // Trigger event with excluded permissions
                        ]);
                        $$('dataview').clearAll(); // Clear data view
                        $$('dataview').parse(excludedPermissions); // Populate data view with excluded permissions
                        $$('FilterFather').getList().clearAll(); // Clear filter options
                        $$('FilterFather').getList().parse(filterList); // Populate filter options
                        $$('FilterFather').setValue(''); // Reset filter selection
                        $$('b5').collapse(); // Collapse filters section
                        $$('dataview').scrollTo(100, 0); // Scroll data view
                    },
                });
        });

        // Event handler for creating a permission
        this.on(this.app, 'createPermission:button', (filter) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'UserManagement/GetAllMenus', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text); // Parse response data
                        if (!data.HasError) {
                            data.Data.forEach((item) => {
                                item.value = item.description; // Set display value for menu items
                                if (item.data != undefined) {
                                    item.data.forEach((item2) => {
                                        item2.value = item2.description; // Set display value for submenu items
                                    });
                                }
                            });
                            if (data.Data.length > 0) {
                                popupAdd = webix
                                    .ui({
                                        view: 'window', // Popup window for creating permission
                                        id: 'CreatePermission',
                                        fullscreen: screen.width < 500 ? true : false,
                                        head: {
                                            view: 'toolbar',
                                            cols: [
                                                {
                                                    view: 'label',
                                                    label: _(
                                                        'Crear Permiso', // Label for the popup
                                                    ),
                                                },
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close popup on icon click
                                                    },
                                                },
                                            ],
                                        },
                                        position: 'center',
                                        modal: true,
                                        body: {
                                            view: 'form', // Form inside the popup
                                            id: 'createPermissionForm',
                                            elements: [
                                                {
                                                    margin: 10,
                                                    rows: [
                                                        {
                                                            view: 'text', // Input for URL
                                                            labelPosition: 'top',
                                                            label: _('Url'), // URL label
                                                            name: 'Url',
                                                            required: true, // Field is required
                                                        },
                                                        {
                                                            view: 'text', // Input for description
                                                            labelPosition: 'top',
                                                            label: _(
                                                                'Descripción', // Description label
                                                            ),
                                                            name: 'Description',
                                                            required: true, // Field is required
                                                        },
                                                        {
                                                            view: 'combo', // Combo for parent menu selection
                                                            labelPosition: 'top',
                                                            label: _(
                                                                'Menú Padre', // Parent menu label
                                                            ),
                                                            name: 'FatherMenu',
                                                            options: data.Data, // Options from API response
                                                            required: false,
                                                            on: {
                                                                onChange: function () {
                                                                    let currentValue = this.getValue(); // Get selected value
                                                                    let subMenus = []; // Array for submenus
                                                                    if (
                                                                        data.Data.filter((item) => {
                                                                            return item.id == currentValue;
                                                                        }) != undefined
                                                                    ) {
                                                                        subMenus = data.Data.filter((item) => {
                                                                            return item.id == currentValue;
                                                                        })[0].data; // Get submenus for selected parent
                                                                    }
                                                                    $$('SubMenu').define(
                                                                        'options',
                                                                        subMenus, // Set submenu options
                                                                    );
                                                                    $$('SubMenu').refresh(); // Refresh submenu
                                                                },
                                                            },
                                                        },
                                                        {
                                                            view: 'combo', // Combo for submenu selection
                                                            labelPosition: 'top',
                                                            label: _(
                                                                'Sub Menú', // Submenu label
                                                            ),
                                                            name: 'SubMenu',
                                                            id: 'SubMenu',
                                                            options: [],
                                                            required: false,
                                                        },
                                                    ],
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            view: 'button', // Cancel button
                                                            value: _(
                                                                'Cancelar', // Cancel label
                                                            ),
                                                            click: function () {
                                                                this.getTopParentView().hide(); // Close popup on cancel
                                                                $$('createPermissionForm').setValues(
                                                                    $$('createPermissionForm').getCleanValues(), // Reset form values
                                                                );
                                                            },
                                                        },
                                                        {
                                                            view: 'button', // Save button
                                                            type: 'form',
                                                            value: _(
                                                                'Guardar', // Save label
                                                            ),
                                                            click: function ($e) {
                                                                var values = $$('createPermissionForm').getValues(); // Get form values
                                                                if ($$('createPermissionForm').validate()) {
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json',
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'UserManagement/CreatePermission',
                                                                            values, // Send form values to API
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message('Error! '); // Error message on failure
                                                                                },
                                                                                success: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    text = JSON.parse(text); // Parse response data
                                                                                    if (text.HasError) {
                                                                                        webix.message(
                                                                                            'Error: ' +
                                                                                                text.AlertMessage, // Show error message if any
                                                                                        );
                                                                                    } else {
                                                                                        webix.message(
                                                                                            'Permiso creado satisfactoriamente', // Success message
                                                                                        );
                                                                                    }
                                                                                },
                                                                            },
                                                                        );
                                                                    this.getTopParentView().hide(); // Close popup after saving
                                                                } else {
                                                                    webix.message({
                                                                        title: _(
                                                                            '¡Error!', // Error title
                                                                        ),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Completa los campos...', // Error message for validation
                                                                        ),
                                                                    });
                                                                }
                                                            },
                                                        },
                                                    ],
                                                },
                                            ],
                                            elementsConfig: {
                                                on: {
                                                    onChange: function () {
                                                        this.validate(); // Validate form on change
                                                    },
                                                },
                                            },
                                        },
                                    })
                                    .show(); // Show the popup
                                $$('createPermissionForm').clearValidation(); // Clear validation state
                            }
                        }
                    },
                });
        });
    }
}

// FILE DOCUMENTED
